// extracted by mini-css-extract-plugin
module.exports = {"heading":"Canvas_heading__1OCne","frame":"Canvas_frame__ApIOs","source":"Canvas_source__22ZpW"};